import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api-data.service';
import { URLS } from '../_config/api.config';

// Ported from customer-website's LoginConfigService so the login/registration
// shell's logo + hero image can come from the backend at runtime instead of
// being hardcoded, same as customer-website.
export interface ImageConfig {
	image_config_id: number;
	title: string;
	description: string;
	image_url: string;
	image_type: 'logo' | 'login';
	is_active: boolean;
}

export interface ImageConfigResponse {
	code: number;
	message: string;
	data: ImageConfig[];
}

@Injectable({
	providedIn: 'root',
})
export class LoginConfigService {
	constructor(private _apiService: ApiService) { }

	getLogoConfig(): Observable<ImageConfigResponse> {
		return this._apiService.get(URLS.logoConfig);
	}

	getLoginConfig(): Observable<ImageConfigResponse> {
		return this._apiService.get(URLS.loginConfig);
	}

	getHeaderConfig(): Observable<ImageConfigResponse> {
		return this._apiService.get(URLS.headerLogoConfig);
	}

	getFooterConfig(): Observable<ImageConfigResponse> {
		return this._apiService.get(URLS.footerLogoConfig);
	}

	getFavIconConfig(): Observable<ImageConfigResponse> {
		return this._apiService.get(URLS.favIconLogoConfig);
	}
}
